import { Component, Output, EventEmitter } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

import { DiscardModel } from '../../../../../core/models/edit-fac-modal.model';

@Component({
  selector: 'app-discard-popup',
  templateUrl: './discard-popup.component.html',
  styleUrls: ['./discard-popup.component.scss']
})

export class DiscardPopupComponent {
  @Output() closeModal: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() discartEvent: EventEmitter<DiscardModel> = new EventEmitter<DiscardModel>();

  public discardForm = this.formBuilder.group({
    reason: ['', [Validators.required]],
    observation: ['', [Validators.required]],
    discarded: [true]
  });
  public openReason = false;
  public dropDownOptions = [
    'Corretor / Profissional',
    'Perfil de teste',
    'Não foi possível o contato',
    'Contato Inexistente',
    'Cliente solicitou exclusão',
    'Outros',
  ];

  constructor(
    private formBuilder: FormBuilder
  ) { }

  setReason(value: string) {
    this.discardForm.get('reason').patchValue(value);
    this.discardForm.get('reason').updateValueAndValidity();
  }
}
